import { createGlobalStyle } from 'styled-components';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Reset = createGlobalStyle`
html, body, div, nav {
margin: 0;
padding: 0;
border: 0;
box-sizing: border-box;
scroll-behavior: smooth;
}
body {
background-color: white;

min-height: 100vh;
}
* {
  outline: none;
}

h1,h2,h3,h4,h5,h6 {
  line-height: 1;
}

.cc-banner .cc-message {
  color: #333333 !important;
  text-align: right;
  max-width: 60% !important;
  font-size: 15px;

  @media (max-width: 414px) {
    text-align: unset;
    max-width: 100% !important;
  }
}

.cc-compliance {
  a {
    font-family: 'Lato', sans-serif !important;
    text-transform: uppercase;
    font-weight: 900 !important;
    font-size: 13px;
  }
}

.slick-dots,
  .slick-active {
    button::before {
      color: #2253f5 !important;
    }
  }

.slick-dots{
  margin-bottom: 2.8rem;
}

`;

export default Reset;
